/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const fuelTypeJSON = async (): Promise<any> => {
  const deviceFuel = useJSONStore.getState().deviceFuel;
  const token = useUserStore.getState().userToken;
  const setDeviceFuel = useJSONStore.getState().setDeviceFuel;

  if (deviceFuel.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.deviceFuel}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setDeviceFuel(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default fuelTypeJSON;
